import React, { useEffect, useState } from "react";
import Login from "../pages/Login/Login";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveSpecifications } from "./../reduxadmin/Actions/index";

const Auth = (props) => {
  console.log("test7",props)
  const [authenticated, setAuthenticated] = useState(false);
  // const [decoded, setDecoded] = useState({});
  const dispatch = useDispatch();
  const totalNotification = useSelector(
    (state) => state.testRedux.specification
  );
  // const notificationData = useSelector()

  const [roleAuthenticated, setRoleAuthenticated] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    console.log(totalNotification);
    var decoded = {};
    console.log("p: " + props.role);
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
      setAuthenticated(true);
    } else {
      navigate("/login");
    }
    if (token != null) {
      try {
        decoded = jwt_decode(token);
        console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }

    console.log(totalNotification);
    props.role.map((dt, index) => {
      if (dt == decoded.UserRole) {
        setRoleAuthenticated(true);
      }
    });
  }, []);

  if (authenticated && roleAuthenticated) {
    return <div>{props.child}</div>;
  } else if (authenticated) {
    return (
      <div className="d-flex justify-content-center">
        <h3>Not Authenticated</h3>
      </div>
    );
  } else {
    return (
      <span>
        <Login />
      </span>
    );
  }
};

export default Auth;
